import { render, staticRenderFns } from "./LetterForPayment.vue?vue&type=template&id=46b7852a&scoped=true&"
import script from "./LetterForPayment.vue?vue&type=script&lang=js&"
export * from "./LetterForPayment.vue?vue&type=script&lang=js&"
import style0 from "./LetterForPayment.vue?vue&type=style&index=0&id=46b7852a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b7852a",
  null
  
)

export default component.exports